import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/** Translations for the new layer: keys live under `next.` in public/locales/{en,he,fr}. */
export const useNextT = () => {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || "en").slice(0, 2);
  // Stable while the language is: components may key useMemo on `t`.
  const nt = useMemo(() => (key: string, opts?: Record<string, unknown>) => t(`next.${key}`, opts as any) as string, [t]);
  return { t: nt, lang, isRtl: lang === "he" };
};
